export default "__VITE_ASSET__c9b25daa__"